import { find, lowerCase } from 'lodash';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { CountryServices } from '../../../../services';
import { MegaContact } from '../../../../types/contacts';
import { TopUpCountry } from '../../../../types/country';
import { QueryTypes } from '../../../../types/queryTypes';
import { TabsWithTitle } from '../../tabsWithTitle';
import { TopUpInternetContacts } from '../topup-internet-contacts';
import { TopUpInternetPhone } from '../topup-internet-phone';

export const TopupInternet = ({ contacts }: { contacts: MegaContact[] }) => {
  const [step, setStep] = useState<'contact' | 'other'>('other');
  const [countryList, setCountryList] = useState<TopUpCountry[]>([]);
  const [bundleContacts, setBundleContacts] = useState<MegaContact[]>([]);
  const [tabList, setTabList] = useState<{ key: string; title: string }[]>([
    { key: 'other', title: 'Otro Número' },
  ]);

  const countriesQuery = useQuery(
    QueryTypes.GetCountriesForBundle,
    CountryServices.getAllCountriesForBundle
  );

  // we need to filter contacts since we cna only show contacts from
  // the countries that have bundle carrier available
  useEffect(() => {
    if (countriesQuery.status === 'success') {
      setCountryList(countriesQuery.data);

      const newContacts = (contacts || []).filter((contact) => {
        return !!find(countriesQuery.data, (item) => {
          return lowerCase(item.count_cod) === lowerCase(contact.country_code);
        });
      });

      if (newContacts.length > 0) {
        setBundleContacts(newContacts);

        setTabList([
          { key: 'other', title: 'Otro Número' },
          { key: 'contact', title: 'Mis Contactos' },
        ]);
      }
    }
  }, [countriesQuery.status]);

  return (
    <div>
      <TabsWithTitle
        title="Celular a Recargar"
        tabs={tabList}
        activeTab={step}
        wrapperClassName="mt-5"
        onTabChange={(key: string) => setStep(key as 'other' | 'contact')}
      />

      {step === 'other' && <TopUpInternetPhone />}
      {step === 'contact' && <TopUpInternetContacts contacts={bundleContacts} />}
    </div>
  );
};
